// import { NavLink } from "react-router-dom";
// import { routes } from "../routes/routeConfig";
// import { X } from "lucide-react";

// const Sidebar = ({ userRole = "student", open, setOpen }) => {
//   return (
//     <div className="bg-secondary">
//       {/* Overlay (Mobile) */}
//       {open && (
//         <div
//           className="fixed inset-0 bg-black/40 z-40 md:hidden"
//           onClick={() => setOpen(false)}
//         />
//       )}

//       {/* Sidebar */}
//       <aside
//         className={`fixed md:static z-50 top-0 left-0 h-full w-64 bg-secondary shadow-md transform transition-transform
//         ${open ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
//       >

//         {/* Header */}
//         <div className="flex items-center justify-between">

//           <button className="md:hidden" onClick={() => setOpen(false)}>
//             <X />
//           </button>
//         </div>

//         {/* Menu */}
//         <nav className="flex flex-col gap-1 p-3">
//           {routes
//             .filter(
//               (r) =>
//                 r.showInSidebar &&
//                 (!r.role || r.role.includes(userRole))
//             )
//             .map((route) => {
//               const Icon = route.icon;

//               return (
//                 <NavLink
//                   key={route.path}
//                   to={route.path}
//                   onClick={() => setOpen(false)}
//                   className={({ isActive }) =>
//                     `flex items-center gap-3 px-3 py-2 rounded-lg transition ${isActive
//                       ? "bg-primary/10 text-primary font-semibold"
//                       : "text-gray-600 hover:bg-gray-100"
//                     }`
//                   }
//                 >
//                   {Icon && <Icon className="w-5 h-5" />}
//                   <span>{route.title}</span>
//                 </NavLink>
//               );
//             })}
//         </nav>
//       </aside>
//     </div>
//   );
// };

// export default Sidebar;


// import { NavLink } from "react-router-dom";
// import { routes } from "../routes/routeConfig";
// import { X } from "lucide-react";

// const Sidebar = ({
//   userRole = "student",
//   open,
//   setOpen,
// }) => {
//   const sidebarRoutes = routes.filter(
//     (r) =>
//       r.showInSidebar &&
//       (!r.role || r.role.includes(userRole))
//   );

//   return (
//     <>
//       {/* Mobile Overlay */}
//       {open && (
//         <div
//           className="
//             fixed
//             inset-0
//             z-40
//             bg-black/40
//             md:hidden
//           "
//           onClick={() => setOpen(false)}
//         />
//       )}

//       {/* Sidebar */}
//       <aside
//         className={`
//           fixed
//           md:static

//           top-0
//           left-0
//           z-50

//           h-full

//           w-[260px]
//           md:w-[260px]
//           md:min-w-[260px]

//           bg-secondary

//           shadow-md

//           transition-transform
//           duration-300
//           ease-in-out

//           ${open
//             ? "translate-x-0"
//             : "-translate-x-full md:translate-x-0"
//           }
//         `}
//       >
//         {/* Mobile Close */}
//         <div
//           className="
//             flex
//             justify-end
//             p-3
//             md:hidden
//           "
//         >
//           <button
//             type="button"
//             onClick={() => setOpen(false)}
//             className="
//               w-9
//               h-9
//               rounded-full
//               flex
//               items-center
//               justify-center
//               text-gray-600
//             "
//           >
//             <X className="w-5 h-5" />
//           </button>
//         </div>

//         {/* Menu */}
//         <nav
//           className="
//             flex
//             flex-col
//             gap-1

//             p-3

//             w-full
//             min-w-0
//           "
//         >
//           {sidebarRoutes.map((route) => {
//             const Icon = route.icon;

//             return (
//               <NavLink
//                 key={route.path}
//                 to={route.path}
//                 onClick={() => setOpen(false)}
//                 className={({ isActive }) => `
//                   flex
//                   items-center
//                   gap-3

//                   w-full
//                   min-w-0

//                   min-h-[48px]

//                   px-3
//                   py-2

//                   rounded-xl

//                   transition-all
//                   duration-200

//                   ${isActive
//                     ? "bg-primary/10 text-primary font-semibold"
//                     : "text-gray-600 hover:bg-gray-100"
//                   }
//                 `}
//               >
//                 {/* Icon */}
//                 {Icon && (
//                   <Icon
//                     className="
//                       w-5
//                       h-5
//                       shrink-0
//                     "
//                     strokeWidth={2.2}
//                   />
//                 )}

//                 {/* Text */}
//                 <span
//                   className="
//                     min-w-0

//                     text-[16px]

//                     whitespace-normal
//                     break-words
//                   "
//                 >
//                   {route.title}
//                 </span>
//               </NavLink>
//             );
//           })}
//         </nav>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;


import { NavLink } from "react-router-dom";
import { routes } from "../routes/routeConfig";
import { X, ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthProvider";

const Sidebar = ({
  userRole,
  open,
  setOpen,
}) => {
  const { user } = useAuth();

  let storedUser = {};
  try {
    storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    storedUser = {};
  }

  const currentRole =
    userRole ||
    user?.roleName ||
    user?.role ||
    storedUser?.roleName ||
    storedUser?.role ||
    "student";

  const normalizedRole = String(currentRole).toLowerCase();

  const sidebarRoutes = routes.filter(
    (r) =>
      r.showInSidebar &&
      (!r.role || r.role.includes(normalizedRole))
  );

  return (
    <>
      {/* Mobile Overlay */}
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed md:static
          top-0 left-0
          z-50

          h-full
          w-[260px]
          md:w-[260px]
          md:min-w-[260px]

          bg-secondary
          shadow-md

          transition-transform
          duration-300
          ease-in-out

          ${open
            ? "translate-x-0"
            : "-translate-x-full md:translate-x-0"
          }
        `}
      >
        {/* Mobile Close */}
        <div className="flex justify-end p-3 md:hidden">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="
              w-9 h-9
              rounded-full
              flex items-center justify-center
              text-gray-600
              hover:bg-gray-100
            "
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Menu */}
        <nav className="flex flex-col gap-1 p-3 w-full min-w-0">
          {sidebarRoutes.map((route) => {
            const Icon = route.icon;

            return (
              <NavLink
                key={route.path}
                to={route.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `
                  group

                  flex
                  items-center
                  justify-between

                  w-full
                  min-w-0
                  min-h-[48px]

                  px-3
                  py-2

                  rounded-xl

                  transition-all
                  duration-200

                  ${isActive
                    ? "bg-[#E8E2E7] text-[#3f35c7] font-semibold"
                    : "text-gray-600 hover:bg-gray-100"
                  }
                `}
              >
                {({ isActive }) => (
                  <>
                    {/* Left */}
                    <div className="flex items-center gap-3 min-w-0">
                      {Icon && (
                        <Icon
                          className="w-5 h-5 shrink-0"
                          strokeWidth={2.2}
                        />
                      )}

                      <span
                        className="
                          min-w-0
                          text-[16px]
                          whitespace-normal
                          break-words
                        "
                      >
                        {route.title}
                      </span>
                    </div>

                    {/* Right Arrow */}
                    <span
                      className={`
                        w-8 h-8
                        ml-2
                        shrink-0

                        flex
                        items-center
                        justify-center

                        rounded-full

                        transition-all
                        duration-200

                        ${isActive
                          ? "bg-[#3f35c7] text-white"
                          : "bg-[#F0EBDF] text-[#B5AD9D]"
                        }
                      `}
                    >
                      <ChevronRight
                        className="w-4 h-4"
                        strokeWidth={2}
                      />
                    </span>
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
